/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Logo from '../Logo/Logo';
import { Col, Container, Row, } from "react-bootstrap";
import Loader from './../Loader/Loader.js';
import { useForm } from 'react-hook-form';
import { Shadow, WerfenColorMid, White } from '../../Constants/ColorChart';
import { withRouter } from "react-router-dom";
import { Wrapper } from '../../CommonForm/StyledFormComponents';
import FieldGroup from './../../CommonForm/FieldGroup';
import { SamlLoginURL } from '../../Constants/AppData';

const COMPANY_DOMAIN = '@werfen.com';
const isEntraLoginEnabled = process.env.REACT_APP_SEE_ENTRA_LOGIN === '1';

/*
 *  @Description:   Component that shows a password recovery form
 */


// noinspection DuplicatedCode
const sendDataToVerify = ( params ) => {
    return new Promise ( ( resolve, reject ) => {
        fetch ( params.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify ( params.dataToSend ),
        } ).then (
            ( res ) => {
                params.methodLoading ( false );
                if ( res.status === 200 ) {
                    params.methodSuccess ( true );
                    if ( params.methodCallback !== undefined ) {
                        params.methodCallback ();
                        resolve ( true )
                    }
                } else {
                    params.methodFailure ( true );
                    resolve ( false )
                }
            }
        ).catch ( ( err ) => {
            params.methodLoading ( false );
            params.methodFailure ( true );
            reject ( err );
        } );
    } )
}

const PasswordRecovery = ( props ) => {
    const { register, handleSubmit, getValues, errors } = useForm ();
    const [ emailVerified, setEmailVerified ] = useState ( false );
    const [ tokenVerified, setTokenVerified ] = useState ( false );
    const [ isTokenValid, setTokenValid ] = useState ( false );
    const [ emailError, setEmailError ] = useState ( false );
    const [ passwordVerified, setPasswordVerified ] = useState ( false );
    const [ passwordError, setPasswordError ] = useState ( false );
    const [ isLoading, setLoading ] = useState ( false );
    const [ hashData, setHashData ] = useState ( null );
    const [ uidData, setUidData ] = useState ( null );
    const [ timestampData, setTimeStampData ] = useState ( null );
    const [ linkConfirmation, setLinkConfirmation ] = useState ( false );
    const [ samlRequired, setSamlRequired ] = useState ( false );

    const onEmailSubmit = data => {
        // @werfen.com accounts sign in with Microsoft, they have no password to recover.
        const isCompanyEmail = ( data.mail || '' ).trim ().toLowerCase ().endsWith ( COMPANY_DOMAIN );
        setSamlRequired ( isEntraLoginEnabled && isCompanyEmail );
        if ( isEntraLoginEnabled && isCompanyEmail ) {
            setEmailError ( false );
            return;
        }

        const emailUrl = process.env.REACT_APP_BACKEND_MACHINE + '/user/reset-password-hash';
        const emailToSend = data;
        setLoading ( true );
        const params = {
            dataToSend: emailToSend,
            url: emailUrl,
            methodLoading: setLoading,
            methodSuccess: setEmailVerified,
            methodFailure: setEmailError
        }
        // noinspection JSUnusedLocalSymbols
        sendDataToVerify ( params )
            .then ( ( response ) => setEmailError ( !response ) )
            .catch ( ( error ) => {
                // console.error(error)
            } );
    }
    const redirect = () => {
        setTimeout ( () => window.location.assign ( '/' ), 4000 );
    }

    const onPasswordSubmit = data => {
        const urlPassword = process.env.REACT_APP_BACKEND_MACHINE + '/user/reset-password-set-password';
        data.hash = hashData;
        data.uid = uidData;
        data.timestamp = timestampData;
        delete data.new_password_repeat;
        const passwordToSend = data;
        setLoading ( true );

        const params = {
            dataToSend: passwordToSend,
            url: urlPassword,
            methodLoading: setLoading,
            methodSuccess: setPasswordVerified,
            methodFailure: setPasswordError,
            methodCallback: redirect
        }
        // noinspection JSUnusedLocalSymbols
        sendDataToVerify ( params )
            .then ( ( response ) => {
                setPasswordVerified ( response );
                setPasswordError ( !response );
            } )
            .catch ( ( error ) => {
                // console.error(error);
            } );
    }

    useEffect ( () => {
        const hashData = props.match.params.hash;
        const uidData = props.match.params.uid;
        const timestampData = props.match.params.timestamp;

        if ( hashData && uidData && timestampData ) {

            setHashData ( hashData );
            setUidData ( uidData );
            setTimeStampData ( timestampData );
            setLinkConfirmation ( true );
            setLoading ( true );

            const url = process.env.REACT_APP_BACKEND_MACHINE + '/user/reset-password-validate-hash';
            const dataToSend = {
                hash: hashData,
                uid: uidData,
                timestamp: timestampData
            };

            // noinspection JSUnusedLocalSymbols
            fetch ( url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify ( dataToSend ),
            } )
                .then (
                    ( res ) => {
                        setLoading ( false );
                        if ( res.status === 200 ) {
                            setTokenVerified ( true );
                            return res.json ();
                        }
                    }
                )
                .then ( ( data ) => {
                    if ( data.message === "valid" ) {
                        setTokenValid ( true );
                    }
                } )
                .catch ( ( err ) => {
                    setLoading ( false );
                    // console.error(err);
                } );
        } else {
            props.history.push ( "/password_recovery" );
        }
    }, [] );

    return <Wrapper className={ "AutoEnrollment" }>
        <div className={ "Stage" }>
            <div className={ "Logo" }>
                <Logo/>
            </div>
            <Container>
                <Row>
                    { isLoading &&
                    <Loader
                        message="Loading content"
                        primaryColor={ WerfenColorMid }
                        secondaryColor={ Shadow }
                        fontColor={ White }/>
                    }

                    { !isLoading && !linkConfirmation && !emailVerified &&
                    <form onSubmit={ handleSubmit ( onEmailSubmit ) } className={ "Form Form-autoenrollment" }>
                        <Col xs={ 12 } md={ { span: 6, offset: 3 } }>
                            <p>Please enter your email address that we can send you a link for resetting your
                                password.
                            </p>
                            <div style={ { position: "relative" } }>
                                <FieldGroup
                                    id="mail"
                                    type="email"
                                    label="Email address*"
                                    name="mail"
                                    className={ "" }
                                    register={ register }
                                    placeholder="Enter your email address"
                                    error={ errors["mail"] }
                                    help={ "This field is required" }
                                    required={ true }
                                />
                                { emailError && <span className={ "helpBlock" }>Email is invalid.</span> }
                                { samlRequired &&
                                <p className={ "helpBlock" }>
                                    The authentication system has changed. Please log in with your @werfen.com
                                    account using the "Sign in with Microsoft" option.{ ' ' }
                                    <a href={ SamlLoginURL }>Sign in with Microsoft</a>
                                </p> }
                            </div>
                        </Col>
                        <Col xs={ 12 }>
                            <input className="buttonSubmit" value="submit"
                                   type="submit"/>
                        </Col>
                    </form> }

                    { !isLoading && !linkConfirmation && emailVerified &&
                    <div className="confirmation-message">
                        <p>Thank you for sending us your email address. </p>
                        <p>You'll receive an email with a link to reset your password.</p>
                    </div> }

                    { !isLoading && linkConfirmation && tokenVerified &&
                    <form onSubmit={ handleSubmit ( onPasswordSubmit ) } className={ "Form Form-autoenrollment" }>
                        <Col xs={ 12 } md={ { span: 6, offset: 3 } }>
                            { !isTokenValid && !passwordVerified &&
                            <div className="confirmation-message">
                                <p>Some error has occurred.</p>
                                <p>Please contact your administrator.</p>
                            </div> }
                            { passwordError && !isLoading && <div className="confirmation-message">
                                <p>There was an error.</p>
                                <p>Please contact your administrator.</p>
                            </div> }
                            { isTokenValid && !passwordVerified &&
                            <div>
                                <p>Enter new password</p>
                                <FieldGroup
                                    id="new_password"
                                    label="Password*"
                                    type="password"
                                    name="new_password"
                                    className={ "" }
                                    refObject={ {
                                        required: "This field is required",
                                        pattern: {
                                            // value:/((?=.*?[A-Z]{1,})(?=.*?[a-z]{1,})(?=.*?[0-9]{1,})(?=.*?[#?!@$%^&*-,.])).{8,}/,
                                            value: /((?=.*?[A-Z]+)(?=.*?[a-z]+)(?=.*?[0-9]+)(?=.*?\W)).{8,}/,
                                            message: "A password needs to have 1 uppercase, 1 lowercase, 1 digit, 1 symbol and be at least 8 characters long."
                                        }
                                    } }
                                    register={ register }
                                    placeholder="Enter your new password"
                                    error={ errors["new_password"] }
                                    help={ "This field is required" }
                                    required={ true }
                                />
                                <FieldGroup
                                    id="new_password_repeat"
                                    label="Repeat password*"
                                    type="password"
                                    name="new_password_repeat"
                                    className={ "" }
                                    register={ register }
                                    placeholder="Repeat your password"
                                    error={ errors["new_password_repeat"] }
                                    help={ "This field is required" }
                                    message={ 'Passwords should match!' }
                                    refObject={ {
                                        required: 'Please confirm password!',
                                        validate: {
                                            matchesPreviousPassword: ( value ) => {
                                                const { new_password } = getValues ();
                                                return new_password === value || 'Passwords should match!';
                                            },
                                        }
                                    } }
                                />

                                <input className="buttonSubmit" value="submit" type="submit"/>
                            </div>
                            }
                            { isTokenValid && passwordVerified &&
                            <div className="confirmation-message">
                                <p>Your password has been reset successfully.</p>
                            </div>
                            }
                        </Col>
                    </form> }
                </Row>
            </Container>
        </div>
    </Wrapper>
};

export default withRouter ( PasswordRecovery );

